export const GOOGLE_MAP_3D_IMAGERY_SETTINGS = {
  // Lock the map to a flat 2D perspective, preventing 3D engine from taking over at high zoom levels.
  // The 3D layer is throwing the error "Sorry, we have no imagery here." for some customers.
  tilt: 0,
  // Hide the button that controls the orientation of 3D imagery.
  rotateControl: false
};

export const MAP_SUGGESTED_ZOOM_LEVEL = 17;
export const GOOGLE_MAP_MAX_ZOOM = 21;
